// extracted by mini-css-extract-plugin
export default {"Text":"style_Text__k7KUh"};